// extracted by mini-css-extract-plugin
export default {"user-rank__container":"styles_user-rank__container__tv5O3","user-rank__ribbon":"styles_user-rank__ribbon__3QIpS"};